<div class="w-full justify-center items-center text-center">
  <!--  <router-outlet></router-outlet>-->
  <!--  <app-search-bar></app-search-bar>-->
  <!--  <app-affiliation></app-affiliation>-->
</div>
